export const GET_ALL_PRODUCTS_REQUEST = "GET_ALL_PRODUCTS_REQUEST";
export const GET_ALL_PRODUCTS_SUCCESS = "GET_ALL_PRODUCTS_SUCCESS";
export const GET_ALL_PRODUCTS_FAILURE = "GET_ALL_PRODUCTS_FAILURE";

export const TEMP_FORM_REQUEST = "TEMP_FORM_REQUEST";
export const TEMP_FORM_SUCCESS = "TEMP_FORM_SUCCESS";
export const TEMP_FORM_FAILURE = "TEMP_FORM_FAILURE";

export const ADD_FORM_REQUEST = "ADD_FORM_REQUEST";
export const ADD_FORM_SUCCESS = "ADD_FORM_SUCCESS";
export const ADD_FORM_FAILURE = "ADD_FORM_FAILURE";

export const DELETE_FORM_REQUEST = "DELETE_FORM_REQUEST";
export const DELETE_FORM_SUCCESS = "DELETE_FORM_SUCCESS";
export const DELETE_FORM_FAILURE = "DELETE_FORM_FAILURE";

export const SINGLE_PRODUCT_REQUEST = "SINGLE_PRODUCT_REQUEST";
export const SINGLE_PRODUCT_SUCCESS = "SINGLE_PRODUCT_SUCCESS";
export const SINGLE_PRODUCT_FAILURE = "SINGLE_PRODUCT_FAILURE";